import { Component, Input } from '@angular/core';
import {
  AbstractControl,
  FormGroup,
  ReactiveFormsModule,
} from '@angular/forms';
import {
  CardModule,
  CheckboxModule,
  DropdownModule,
  RadioButtonModule,
  AlertModule,
  TooltipModule,
} from 'axis-components';
import { CommonModule, JsonPipe, SlicePipe } from '@angular/common';
import { BaseRules, TextValues } from './arkansas-model';
import { UimuiBaseStateComponent } from '../uimui-base-state.component';
import { TruncateModule } from 'axis-components/truncate';

@Component({
  selector: 'app-arkansas',
  standalone: true,
  imports: [
    CardModule,
    CheckboxModule,
    CommonModule,
    DropdownModule,
    ReactiveFormsModule,
    RadioButtonModule,
    AlertModule,
    SlicePipe,
    TruncateModule,
    TooltipModule
  ],
  templateUrl: './arkansas.component.html',
})
export class ArkansasComponent extends UimuiBaseStateComponent<
  BaseRules,
  TextValues
> {
  @Input() set formGroup(form: FormGroup | null) {
    if (form) {
      super.getJsonRuleFiles('arkansas', form);
      this.addCombinedSingleLimitToPdfDump();
    }
  }
  @Input() set isReview(review: boolean) {
    if (review) {
      super.getJsonRuleFiles('arkansas', null);
    }
  }

  private addCombinedSingleLimitToPdfDump(): void {
    if (
      this.baseRules?.selectionId !==
      'PolicyLiabilityLimits_CombinedSingleLimit_BodilyInjuryWithOptionalPropertyDamage'
    ) {
      return;
    }

    if (!this.baseRulesService.pdfDataDump['arkansas']) {
      this.baseRulesService.pdfDataDump['arkansas'] = {};
    }

    this.baseRulesService.pdfDataDump['arkansas'] = {
      ...this.baseRulesService.pdfDataDump['arkansas'],
      combinedsinglelimit_leveltwoumpd_radio: true,
    };
  }
}
